/**
 * undo/redo 히스토리 — JSON 스냅샷 스택. 스냅샷 배열/포인터만 소유하고,
 * DOM 복원(restore)과 변경 알림(fireChange)은 주입받아 editor 수명주기와 분리한다.
 *
 *   const hist = createHistory({ getDocument, restore, fireChange });
 *   hist.commit();               // 현재 문서를 1스텝으로(동일 스냅샷은 코얼레싱)
 *   hist.undo(); hist.redo();    // 복원 + 알림
 *   hist.canUndo(); hist.canRedo();
 */
export function createHistory({ getDocument, restore, fireChange }) {
  let history = [];
  let index = -1;
  const eq = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  function commit() {
    const snap = getDocument();
    if (index >= 0 && eq(history[index], snap)) return false;
    history = history.slice(0, index + 1);
    history.push(snap);
    index = history.length - 1;
    return true;
  }
  function undo() {
    if (index > 0) {
      index--;
      restore(history[index]);
      fireChange();
      return true;
    }
    return false;
  }
  function redo() {
    if (index < history.length - 1) {
      index++;
      restore(history[index]);
      fireChange();
      return true;
    }
    return false;
  }

  return {
    commit,
    undo,
    redo,
    canUndo: () => index > 0,
    canRedo: () => index < history.length - 1,
  };
}
